import { useSyncExternalStore } from "react";
import { connectionStatus } from "../utils/connectionStatus";

/** True while the dashboard has no internet connection. */
const useIsOffline = (): boolean =>
  useSyncExternalStore(connectionStatus.subscribe, connectionStatus.isOffline);

export default useIsOffline;
